import {createUseQuery} from "@irati/utils/services/apollo"

import {powerbiReport, powerbiReportKey} from "./query/powerbiReport"

export const usePowerbiReportDetails = createUseQuery(powerbiReport, {key: powerbiReportKey})
